module.exports = __webpack_public_path__ + "static/media/spinner.6b121394.gif";